import React from "react";
import india_chl_img from "../pictures/download__3_-removebg-preview-1.png";
import cw_logo_img from "../pictures/CW-Logo-jp-1.jpg";
import IBN7_img from "../pictures/IBN7_logo-White_Background-1.jpg";
import india_today_img from "../pictures/INDIA_TODAY_LOGO_for_Print_Approved-1.png";
import nirvar_img from "../pictures/nirvaan-Logo-New.png";
import UBF_img from "../pictures/UBF-Logo.png";
import newsindia_img from "../pictures/1522046369917-removebg-preview-1.png";




const Previous_partner = () =>
{
    return(
        <>
        <div className="previous_partner_container">
            <div className="previous_logos_slider">
                <img src={india_chl_img} alt="not"/>
                <img src={cw_logo_img} alt="not"/>
                <img src={IBN7_img} alt="not"/>
                <img src={india_today_img} alt="not"/>
                <img src={nirvar_img} alt="not"/>
                <img src={UBF_img} alt="not"/>
                <img src={newsindia_img} alt="not"/>
            </div>
            <div className="previous_logos_slider">
                <img src={india_chl_img} alt="not"/>
                <img src={cw_logo_img} alt="not"/>
                <img src={IBN7_img} alt="not"/>
                <img src={india_today_img} alt="not"/>
                <img src={nirvar_img} alt="not"/>
                <img src={UBF_img} alt="not"/>
                <img src={newsindia_img} alt="not"/>
            </div>
          </div>
        </>
    )
}

export default Previous_partner;